function init() {
	
	for (const accordion of document.querySelectorAll('[data-accordion]')) {

		const triggers = accordion.querySelectorAll('[data-accordion-item-trigger]')
		const sections = accordion.querySelectorAll('[data-accordion-item-section]')
		
		for (const trigger of triggers) {

			trigger.addEventListener('click', () => {

				// Find out if section is already expanded
				const isExpanded = trigger.getAttribute('aria-expanded')
				
				// If not yet expanded
				if (isExpanded === 'false') {

					// Get if of section controlled by trigger
					const section = document.getElementById(trigger.getAttribute('aria-controls'))

					// Loop through all items and set expanded as false
					for (const item of triggers) {

						item.setAttribute('aria-expanded', 'false')
					}
					for (const item of sections) {

						item.setAttribute('hidden', '')
					}

					trigger.setAttribute('aria-expanded', 'true')
					section.removeAttribute('hidden')
				}
			})
		}
	}
}

export default init